import { AppLanguageEnum, getAbbreviationsByAppLanguageEnum } from 'localization/appLanguage';
import { ratControlAddressRoute } from 'route/routeRatControl';
import { useHistory } from 'react-router-dom';
import i18next from 'i18next';
import React, { useEffect } from 'react';

const RatControlFr: React.FC<{}> = () => {
    const history = useHistory();

    useEffect(() => {
        i18next.changeLanguage(getAbbreviationsByAppLanguageEnum(AppLanguageEnum.fr)).then(() => {
            history.push(ratControlAddressRoute.url());
        });
    }, [history]);

    return null;
};

export default RatControlFr;
